<template>
  <v-card-title class="rmr-table-shell__header">
    <div class="rmr-table-shell__topline">
      <div :class="['rmr-table-shell__heading', headingClass]">
        <slot name="heading" />
      </div>
      <div :class="['rmr-table-shell__controls', controlsClass]">
        <slot name="controls" />
      </div>
    </div>
  </v-card-title>
</template>

<script>
export default {
  name: "RmrTableHeader",
  props: {
    headingClass: {
      type: [String, Array, Object],
      default: "",
    },
    controlsClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
};
</script>
